import { __assign, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import $ from 'jquery';
import { Consts, window, getResizeMediaUrl, experiments, } from '@wix/photography-client-lib';
import { GalleryItem } from '@wix/pro-layouts-old';
import { utils, prepareFullscreenItem, replaceWindowElement, createFullscreenStyle, } from '../utils';
import { isSEOMode, viewModeWrapper } from '../utils/viewModeWrapper.js';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import DesktopExpand from './DesktopExpand';
import MobileExpand from './MobileExpand';
import '../assets/styles/fullscreen.global.scss';
import withCssFilter from './hoc/withCssFilter';
utils.fixViewport('Fullscreen');
function defaultNavigateAction(url) {
    window.open(url);
}
var ProFullscreen = /** @class */ (function (_super) {
    __extends(ProFullscreen, _super);
    function ProFullscreen(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMouseMove = _.throttle(function () {
            $('.fullscreen-icon').show().css('opacity', '1');
            $('body').removeClass('no-cursor');
            clearTimeout(_this.mouseMovedTimeout);
            if (_this.state.isFullscreen && utils.isMobile()) {
                if (!_this.getItem().isDemo && !utils.isTouch()) {
                    _this.mouseMovedTimeout = setTimeout(function () {
                        $('body').addClass('no-cursor');
                        $('.fullscreen-icon').css('opacity', '0');
                    }, 3000);
                }
            }
        }, 100).bind(_this);
        _this.handleKeypress = _.throttle(function (e) {
            var isRTL = _this.props.styles.isRTL;
            switch (e.keyCode || e.charCode) {
                case 37: // left
                case 33: // page up
                    e.preventDefault();
                    _this.nextSlide(isRTL ? 1 : -1);
                    return false;
                case 39: // right
                case 34: // page down
                    e.preventDefault();
                    _this.nextSlide(isRTL ? -1 : 1);
                    return false;
                case 27: // esc
                    e.preventDefault();
                    _this.handleMouseMove();
                    _this.closeBrowserFullscreen();
                    return false;
                case 9: // tab
                    var activeElementClasses = document.activeElement.classList;
                    if (e.shiftKey) {
                        if (activeElementClasses.contains('pro-fullscreen-arrow') && // one of the arrows
                            (activeElementClasses.contains('arrow-left') || // left arrow
                                (activeElementClasses.contains('arrow-right') && // or right arrow when left arrow is disabled
                                    _this.state.current.idx <= 0))) {
                            // the left arrow or (the right arrow when left arrow is disabled) is the last icon in the shift-tab-order.
                            // if another shift-tab was pressed, we want to focus again on the close icon
                            e.preventDefault();
                            _this.setState({ shouldRefocusOnCloseXButton: true }, function () {
                                _this.setState({ shouldRefocusOnCloseXButton: false });
                            });
                            return false;
                        }
                    }
                    else {
                        if (activeElementClasses.contains('pro-fullscreen-x-button')) {
                            // close icon is the last icon in fullscreen tab-order.
                            // if another tab was pressed, we want to focus again on one of the arrows (the correct one).
                            _this.setState({ refocusArrows: true }, function () {
                                _this.setState({ refocusArrows: false });
                            });
                            return false;
                        }
                    }
                    break;
                default:
            }
            _this.handleMouseMove();
            return true; // continue handling the original keyboard event
        }, 100).bind(_this);
        _this.onFullscreenChange = function () {
            // exit fullscreen
            if (!window.document.fullscreenElement &&
                !window.document.webkitIsFullScreen &&
                !window.document.mozFullScreen &&
                !window.document.msFullscreenElement) {
                if (_this.state.isFullscreen) {
                    _this.setState({
                        isFullscreen: false,
                        showInfo: _this.props.styles.defaultShowInfoExpand &&
                            _this.state.current.hasInfo,
                        infoToggledByUser: false,
                    });
                }
            }
        };
        _this.setIsSwipping = _.debounce(function (bool) { return (_this.isSwipping = bool); }, 300).bind(_this);
        _this.eventsListener = _this.eventsListener.bind(_this);
        _this.fadeToNextSlide = _this.fadeToNextSlide.bind(_this);
        _this.toggleFullscreen = _this.toggleFullscreen.bind(_this);
        _this.nextSlide = _this.nextSlide.bind(_this);
        _this.toggleShareScreen = _this.toggleShareScreen.bind(_this);
        _this.toggleInfo = _this.toggleInfo.bind(_this);
        _this.openBrowserFullscreen = _this.openBrowserFullscreen.bind(_this);
        _this.closeBrowserFullscreen = _this.closeBrowserFullscreen.bind(_this);
        _this.handleOnTap = _this.handleOnTap.bind(_this);
        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.toggleZoom = _this.toggleZoom.bind(_this);
        _this.setRef = _this.setRef.bind(_this);
        _this.setCurrentItem = _this.setCurrentItem.bind(_this);
        // this.handleOrientationChange = this.handleOrientationChange.bind(this);
        if (typeof props.deviceType !== 'undefined') {
            viewModeWrapper.setDeviceType(props.deviceType);
        }
        if (typeof props.viewMode !== 'undefined') {
            viewModeWrapper.setViewMode(props.viewMode);
        }
        _this.extraImages = utils.isMobile() ? 2 : 5; // number of images to preload on each side of the fullscreen
        _this.actions = {
            toggleInfo: _this.toggleInfo,
            toggleShareScreen: _this.toggleShareScreen,
            next: _this.nextSlide,
            openBrowserFullscreen: _this.openBrowserFullscreen,
            closeBrowserFullscreen: _this.closeBrowserFullscreen,
            eventsListener: _this.eventsListener,
            toggleFullscreen: _this.toggleFullscreen,
            fadeToNextSlide: _this.fadeToNextSlide,
            toggleZoom: _this.toggleZoom,
            setCurrentItem: _this.setCurrentItem,
        };
        // TODO: replace with css modules
        replaceWindowElement({
            type: 'style',
            id: 'inlineDynamicFullscreenWixParamsCss',
            attributes: { type: 'text/css' },
            innerHTML: createFullscreenStyle(props.styles),
            parentElement: window.document.getElementsByTagName('head')[0],
        });
        if (props.styles.googleFontsCssUrl) {
            replaceWindowElement({
                type: 'style',
                id: 'inlineDynamicFullscreenWixParamsFont',
                attributes: {
                    type: 'text/css',
                    rel: 'stylesheet',
                    href: props.styles.googleFontsCssUrl,
                },
                parentElement: window.document.getElementsByTagName('head')[0],
            });
        }
        _this.itemClickIsOpenInFullscreen = props.styles.itemClick === 'fullscreen';
        _this.state = {
            isFullscreen: _this.itemClickIsOpenInFullscreen,
            animating: false,
            showShareScreen: false,
            showShare: false,
            refocusArrows: false,
            initialArrowsFocus: false,
            shouldRefocusOnCloseXButton: false,
            isMobileZoom: false,
            shouldRotateBackToExpand: false,
        };
        _this.state.currentWindow = _this.getCurrentWindowState();
        _this.state.current = _this.getItemStateByIdx(props.initialIdx);
        var eventData = {
            item: _this.state.current.item,
        };
        _this.eventsListener(FULLSCREEN_EVENTS.UPDATE_CURRENT_ITEM, eventData);
        _this.state.showInfo =
            props.styles &&
                !_this.itemClickIsOpenInFullscreen &&
                props.styles.defaultShowInfoExpand &&
                _this.state.current.hasInfo;
        return _this;
    }
    ProFullscreen.prototype.eventsListener = function (eventName, eventData) {
        if (typeof this.props.eventsListener === 'function') {
            this.props.eventsListener(eventName, eventData);
        }
    };
    ProFullscreen.prototype.handleOrientationChange = function () {
        var _a = this.state, shouldRotateBackToExpand = _a.shouldRotateBackToExpand, isFullscreen = _a.isFullscreen;
        if (!this.itemClickIsOpenInFullscreen) {
            if (shouldRotateBackToExpand) {
                this.setState({
                    shouldRotateBackToExpand: false,
                    isFullscreen: false,
                });
            }
        }
    };
    ProFullscreen.prototype.initEvents = function () {
        window.addEventListener('keydown', this.handleKeypress);
        window.addEventListener('fullscreenchange', this.onFullscreenChange);
        window.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
        window.addEventListener('mozfullscreenchange', this.onFullscreenChange);
        window.addEventListener('MSFullscreenChange', this.onFullscreenChange);
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mousedown', this.handleMouseMove);
        window.addEventListener('touchstart', this.onTouchStart, {
            passive: false,
        });
        window.addEventListener('touchmove', this.onTouchMove, { passive: false });
        window.addEventListener('touchend', this.onTouchEnd, { passive: false });
    };
    ProFullscreen.prototype.clearEvents = function () {
        window.removeEventListener('keydown', this.handleKeypress);
        window.removeEventListener('fullscreenchange', this.onFullscreenChange);
        window.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
        window.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
        window.removeEventListener('MSFullscreenChange', this.onFullscreenChange);
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('mousedown', this.handleMouseMove);
        window.removeEventListener('touchstart', this.onTouchStart, {
            passive: false,
        });
        window.removeEventListener('touchmove', this.onTouchMove, {
            passive: false,
        });
        window.removeEventListener('touchend', this.onTouchEnd, { passive: false });
    };
    // TODO remove state from args
    ProFullscreen.prototype.getItemStateByIdx = function (idx) {
        if (_.isUndefined(idx)) {
            idx = this.state.current.idx || 0;
        }
        var item = this.getItem(idx);
        return {
            idx: idx,
            item: item,
            hasInfo: this.hasInfo(idx),
            pos: this.getItemsDisplayRange(),
            itemLoveData: this.props.itemsLoveData[item.id],
        };
    };
    ProFullscreen.prototype.shouldShowInfo = function () {
        var _a, _b;
        /* Note: It seems that there are 2 props that are responsible for showing fullscreen-sidebar: 'showInfo' and 'shouldShowInfo' - probably historic reasons..
          See more in 'fullscreenSidebar' component -> isVisible() function
          TODO: need to refactor - merge 'showInfo' and 'shouldShowInfo' ?
        */
        if (!this.state && this.itemClickIsOpenInFullscreen) {
            return false;
        }
        else if (this.state && this.state.isFullscreen) {
            return false;
        }
        else if (this.hasAdditionalSidebarElement() && !utils.isMobile()) {
            return true;
        }
        else if (((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.hasInfo) &&
            !utils.isMobile() &&
            this.props.styles.defaultShowInfoExpand) {
            return true;
        }
        else if (this.state) {
            return this.state.showInfo;
        }
        else {
            return this.props.styles.defaultShowInfoExpand && !utils.isSmallScreen();
        }
    };
    ProFullscreen.prototype.getFullscreenDimensions = function () {
        var dim = {
            width: Math.round(this.props.container.width / utils.getViewportScaleRatio()),
            height: Math.round(this.props.container.height / utils.getViewportScaleRatio()),
        };
        return dim;
    };
    ProFullscreen.prototype.getCurrentWindowScale = function () {
        var _this = this;
        var scale = {};
        if (this.state.isFullscreen || utils.isSmallScreen()) {
            scale = {
                horizontal: 1,
                vertical: 1,
            };
        }
        else {
            var w = this.getFullscreenDimensions();
            scale = {
                horizontal: (w.width - 100 * 2) / w.width,
                vertical: (w.height - 100 * 2) / w.height,
            };
        }
        scale.min = function (item) {
            if (_this.state.isFullscreen || utils.isSmallScreen()) {
                return 1;
            }
            else {
                var w = _this.getFullscreenDimensions();
                var horizontal = (w.width - 100 * 2) / item.width;
                var vertical = (w.height - 100 * 2) / item.height;
                return Math.min(horizontal, vertical);
            }
        };
        return scale;
    };
    ProFullscreen.prototype.getCurrentWindowState = function () {
        return {
            size: this.getFullscreenDimensions(),
            expanded: this.state.isFullscreen,
            scale: this.getCurrentWindowScale(),
        };
    };
    ProFullscreen.prototype.hasInfo = function (idx) {
        var curItem;
        if (!_.isUndefined(idx)) {
            curItem = this.getItem(idx);
        }
        else if (_.isUndefined(this.state.current)) {
            return false;
        }
        else {
            curItem = this.getItem(_.get(this, 'state.current.idx') || 0);
        }
        var title = utils.getTitleOrFilename(curItem.title, curItem.fileName) &&
            this.props.styles.allowTitleExpand;
        var description = curItem.description && this.props.styles.allowDescriptionExpand;
        var link = !_.isUndefined(curItem.link.data);
        var hasInfo = title || description || link;
        return hasInfo;
    };
    ProFullscreen.prototype.setCurrentItem = function (item) {
        this.setState({
            currentGalleryItem: item,
        });
        this.nextSlide(null, item.idx);
    };
    ProFullscreen.prototype.getItem = function (idx) {
        var _this = this;
        var emptyItem = function () {
            var _a;
            return new GalleryItem({
                dto: {
                    itemId: 'empty-item',
                    mediaUrl: '',
                    metaData: {
                        height: 3744,
                        width: 3744,
                    },
                },
                createMediaUrl: getResizeMediaUrl({
                    imageToken: _this.props.watermark,
                    staticMediaUrls: _this.props.staticMediaUrls,
                    useOptimizedImageFormat: (_a = _this.props.styles) === null || _a === void 0 ? void 0 : _a.useOptimizedImageFormat,
                }),
            });
        };
        if (!this.state) {
            return emptyItem();
        }
        else if (!_.isUndefined(idx) && _.isArray(this.props.items)) {
            return this.getOrCreateGalleryItem(idx) || emptyItem();
        }
        else if (_.get(this, 'state.current.item.id')) {
            return this.state.current.item;
        }
        else if (_.get(this, 'state.current.idx')) {
            return this.getOrCreateGalleryItem(_.get(this, 'state.current.idx'));
        }
        else if (_.get(this, 'prerenderedItem.id')) {
            return this.prerenderedItem;
        }
        else {
            return emptyItem();
        }
    };
    ProFullscreen.prototype.getNextitem = function (idx, direction) {
        var loop = this.props.styles.fullscreenLoop;
        var numOfitems = this.props.items.length;
        var next = idx + direction;
        if (next < 0) {
            return idx;
        }
        else if (next === numOfitems) {
            return loop ? 0 : idx;
        }
        else {
            return next;
        }
    };
    ProFullscreen.prototype.getItemsDisplayRange = function () {
        var range = utils.isTouch() ? 2 : 5;
        if (!this.state) {
            return range;
        }
        var numOfitems = this.props.items.length - 1;
        if ((numOfitems > 0) & this.props.styles.fullscreenLoop) {
            return Math.min(range, Math.floor(numOfitems / 2));
        }
        else {
            return Math.min(range, numOfitems);
        }
    };
    ProFullscreen.prototype.getOrCreateGalleryItem = function (itemIdx) {
        // calc itemParams and clear cache if one of them had changed
        var itemParams = {
            fullscreenSize: this.getFullscreenDimensions(),
            styles: this.props.styles,
            watermark: this.props.watermark,
            staticMediaUrls: this.props.staticMediaUrls,
        };
        var stringifiedItemParams = JSON.stringify(itemParams);
        var shouldClearGalleryItems = stringifiedItemParams !== this.lastItemParams;
        if (shouldClearGalleryItems) {
            this.galleryItems = [];
            this.lastItemParams = stringifiedItemParams;
        }
        if (!this.galleryItems[itemIdx]) {
            var item = this.props.items[itemIdx];
            this.galleryItems[itemIdx] = item
                ? prepareFullscreenItem(__assign({ item: item, itemIdx: itemIdx, scale: this.getCurrentWindowScale(), isFullscreen: this.state.isFullscreen, watermark: this.props.watermark }, itemParams))
                : undefined;
        }
        return this.galleryItems[itemIdx];
    };
    ProFullscreen.prototype.getMoreItemsIfNeeded = function (nextIdx) {
        if (this.props.totalItemsCount > this.props.items.length &&
            nextIdx > this.props.items.length - this.extraImages) {
            var itemsLength = this.props.items.length;
            this.eventsListener(FULLSCREEN_EVENTS.NEED_MORE_ITEMS, itemsLength);
        }
    };
    ProFullscreen.prototype.closeBrowserFullscreen = function (shouldCloseFullscreen) {
        var _this = this;
        if (shouldCloseFullscreen === void 0) { shouldCloseFullscreen = false; }
        // TODO search expand word, replace with fullscreen
        if (this.state.isFullscreen) {
            this.eventsListener(FULLSCREEN_EVENTS.TOGGLE_BROWSER_FULLSCREEN);
            setTimeout(function () {
                _this.setState({
                    isFullscreen: false,
                    showInfo: _this.props.styles.defaultShowInfoExpand &&
                        _this.state.current.hasInfo,
                    infoToggledByUser: false,
                }, function () {
                    if (shouldCloseFullscreen) {
                        var eventData = {
                            itemIdx: _this.state.current.idx,
                            animationDuration: 0,
                        };
                        _this.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
                    }
                });
            }, 100);
        }
        else {
            var eventData = {
                itemIdx: this.state.current.idx,
            };
            this.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
        }
    };
    ProFullscreen.prototype.openBrowserFullscreen = function () {
        var _this = this;
        // TODO: merge this function, does the same as closeBrowserFullscreen
        this.setState({
            isFullscreen: true,
            showInfo: false,
            infoToggledByUser: false,
        }, function () { return _this.eventsListener(FULLSCREEN_EVENTS.TOGGLE_BROWSER_FULLSCREEN); });
    };
    ProFullscreen.prototype.nextSlide = function (direction, nextIdx, callback) {
        // this method should be called AFTER the animation is finished!
        var _this = this;
        if (!_.isFunction(callback)) {
            callback = _.noop;
        }
        // disable circling photos
        nextIdx =
            _.isUndefined(nextIdx) || _.isNull(nextIdx)
                ? this.getNextitem(Number(this.state.current.idx), direction)
                : nextIdx;
        if (nextIdx === this.state.current.idx) {
            callback();
            return;
        }
        if (_.isUndefined(nextIdx)) {
            callback();
            this.closeFullscreen();
        }
        else {
            var currentItem_1 = this.getItemStateByIdx(nextIdx);
            this.setState({
                current: currentItem_1,
                showInfo: !this.state.isFullscreen &&
                    currentItem_1.hasInfo &&
                    (this.props.styles.defaultShowInfoExpand ||
                        this.state.infoToggledByUser),
                animating: false,
                direction: 0,
            }, function () {
                _this.getMoreItemsIfNeeded(nextIdx);
                _this.eventsListener(FULLSCREEN_EVENTS.ON_NEXT_SLIDE, nextIdx); // iFrame only (pro-fullscreen-tpa-wrapper)
                var eventData = {
                    item: currentItem_1.item,
                };
                _this.eventsListener(FULLSCREEN_EVENTS.UPDATE_CURRENT_ITEM, eventData);
                callback();
            });
        }
    };
    ProFullscreen.prototype.toggleInfo = function (forceVal) {
        if (this.state.isFullscreen) {
            this.setState({ showInfo: false });
        }
        else {
            var showInfo = _.isUndefined(forceVal)
                ? !this.state.showInfo
                : forceVal;
            utils.setStateAndLog(this, 'toggleInfo', { showInfo: showInfo });
            this.setState({ infoToggledByUser: showInfo });
        }
    };
    ProFullscreen.prototype.toggleShareScreen = function () {
        this.setState({
            showShareScreen: !this.state.showShareScreen,
        });
    };
    // --------------------------------------------| UI Actions |-------------------------------------------//
    ProFullscreen.prototype.fadeToNextSlide = function (direction) {
        var _this = this;
        if (direction !== 0 && !this.state.animating) {
            utils.setStateAndLog(this, 'fadeToNextSlide animation start', {
                animating: true,
                direction: direction,
            }, function () {
                setTimeout(function () {
                    _this.actions.next(direction); // triggers react after the animation is complete
                    _this.fixTransformForApple();
                }, 400);
            });
        }
    };
    ProFullscreen.prototype.handleOnTap = function (event) {
        var className = _.get(event, 'target.className') || '';
        if (typeof className === 'string' || className instanceof String) {
            return !this.itemClickIsOpenInFullscreen &&
                (className.indexOf('fullscreen-item') >= 0 ||
                    className.indexOf('fullscreen-preload') >= 0)
                ? this.toggleFullscreen(true)
                : {};
        }
    };
    ProFullscreen.prototype.toggleZoom = function (bool) {
        this.setState({
            isMobileZoom: bool,
        });
    };
    ProFullscreen.prototype.onTouchStart = function (event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
        var className = _.get(event, 'target.className') || '';
        this.isSwipping = false;
        if (typeof className === 'string' || className instanceof String) {
            if (event.touches.length === 2) {
                return className.indexOf('gallery-item') >= 0 ||
                    className.indexOf('te-pro-gallery-text-item') >= 0
                    ? this.toggleZoom(true)
                    : {};
            }
        }
    };
    ProFullscreen.prototype.onTouchMove = function () {
        this.isSwipping = true;
    };
    ProFullscreen.prototype.onTouchEnd = function (event) {
        if (this.isSwipping) {
            this.setIsSwipping(false);
            return;
        }
        var className = _.get(event, 'target.className') || '';
        if (typeof className === 'string' || className instanceof String) {
            return className.indexOf('gallery-item') >= 0 ||
                className.indexOf('te-pro-gallery-text-item') >= 0
                ? this.toggleFullscreen(true)
                : {};
        }
    };
    ProFullscreen.prototype.toggleFullscreen = function (valueOrEvent) {
        if (_.isBoolean(valueOrEvent)) {
            this.setState({
                isFullscreen: valueOrEvent,
            });
        }
        else {
            var tapTargetClass = _.get(valueOrEvent, 'target.className') || '';
            if (typeof tapTargetClass === 'string' ||
                tapTargetClass instanceof String) {
                if (tapTargetClass.indexOf('fullscreen-item') >= 0 ||
                    tapTargetClass.indexOf('fullscreen-preload') >= 0) {
                    // make sure that the tap is on the image / preload
                    this.setState({
                        // TURBO: use prevState func
                        isFullscreen: !this.state.isFullscreen,
                    });
                }
            }
            else {
                // console.log('Not Toggling Zoom Mode', (_.get(tapEvent, 'target.className') || '').indexOf('fullscreen-item'), (_.get(tapEvent, 'target.className')), tapEvent);
            }
        }
    };
    // -----------------------------------------| DOM Manipulation |----------------------------------------//
    ProFullscreen.prototype.fixLinkLineHeight = function () {
        var curItem = this.state.current.item;
        if (curItem.linkUrl && curItem.linkText) {
            // patch to limit link lines to 2
            try {
                var elem = $(ReactDOM.findDOMNode(this));
                if (!elem) {
                    return;
                }
                var link = elem.find('.fullscreen-side-bar-exif.pro-fullscreen-link');
                if (link.length !== 1) {
                    return;
                }
                var lineHeight = parseInt(link.css('line-height'), 10);
                var numOfLines = 2;
                link.height(numOfLines * lineHeight);
                link.css({ '-webkit-line-clamp': numOfLines + '' });
            }
            catch (e) {
                return;
            }
        }
    };
    ProFullscreen.prototype.fixTransformForApple = function () {
        if (utils.isiOS()) {
            $('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform');
        }
        else if (utils.browserIs('safari')) {
            var transform = 'translate3d(0, 0, 0)';
            var duration = '0ms';
            $('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide')
                .css('will-change', 'transform')
                .css('transform', transform)
                .css('-webkit-transform', transform)
                .css('-moz-transform', transform)
                .css('-ms-transform', transform)
                .css('-o-transform', transform)
                .css('transition-duration', duration)
                .css('-webkit-transition-duration', duration)
                .css('-moz-transition-duration', duration)
                .css('-ms-transition-duration', duration)
                .css('-o-transition-duration', duration);
        }
    };
    ProFullscreen.prototype.hasContainerChanged = function (container, prevContainer) {
        return (container.width !== prevContainer.width ||
            container.height !== prevContainer.height);
    };
    // ------------------------------------------| React methods |------------------------------------------//
    ProFullscreen.prototype.componentDidMount = function () {
        if (typeof this.props.deviceType !== 'undefined') {
            viewModeWrapper.setDeviceType(this.props.deviceType);
        }
        this.eventsListener(FULLSCREEN_EVENTS.FULLSCREEN_LOADED, this.state.current.item);
        this.initEvents();
        this.handleMouseMove(); // show the icons (that will show on mouse move) on startup
    };
    ProFullscreen.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        // check is this is really needed (do not do on every state change)
        this.fixLinkLineHeight();
        this.fixTransformForApple();
        var isFullscreen = this.state.isFullscreen;
        var mobileSwipeAnimation = this.props.styles.mobileSwipeAnimation;
        if (utils.isOOI()) {
            if (!prevProps.isAccessible && this.props.isAccessible) {
                this.setState({ initialArrowsFocus: true }, function () {
                    _this.setState({ initialArrowsFocus: false });
                });
            }
        }
        if (this.props.itemsLoveData !== prevProps.itemsLoveData) {
            var currItem = this.getItemStateByIdx(this.state.current.idx);
            this.setState({
                current: currItem,
            });
        }
        if (this.props.viewMode !== prevProps.viewMode) {
            viewModeWrapper.setViewMode(this.props.viewMode);
        }
        if (this.props.deviceType !== prevProps.deviceType) {
            viewModeWrapper.setDeviceType(this.props.deviceType);
        }
    };
    // WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
    ProFullscreen.prototype.componentWillReceiveProps = function (nextProps) {
        if (!_.isEqual(this.props.styles, nextProps.styles) ||
            !_.isEqual(this.props.container, nextProps.container)) {
            replaceWindowElement({
                type: 'style',
                id: 'inlineDynamicFullscreenWixParamsCss',
                attributes: { type: 'text/css' },
                innerHTML: createFullscreenStyle(nextProps.styles),
                parentElement: window.document.getElementsByTagName('head')[0],
            });
            if (nextProps.styles.googleFontsCssUrl) {
                replaceWindowElement({
                    type: 'style',
                    id: 'inlineDynamicFullscreenWixParamsFont',
                    attributes: {
                        type: 'text/css',
                        rel: 'stylesheet',
                        href: nextProps.styles.googleFontsCssUrl,
                    },
                    parentElement: window.document.getElementsByTagName('head')[0],
                });
            }
            this.setState({
                showInfo: !this.state.isFullscreen &&
                    this.state.current.hasInfo &&
                    (nextProps.styles.defaultShowInfoExpand ||
                        this.state.infoToggledByUser),
                currentWindow: this.getCurrentWindowState(),
            });
        }
    };
    ProFullscreen.prototype.componentWillUnmount = function () {
        this.clearEvents();
    };
    // ____________________________________getters_____________________________________
    ProFullscreen.prototype.hasAdditionalSidebarElement = function () {
        var _a = this.props, customMobileSidebarRenderer = _a.customMobileSidebarRenderer, additionalSidebarElement = _a.additionalSidebarElement;
        return ((typeof customMobileSidebarRenderer === 'function' && utils.isMobile()) ||
            (typeof additionalSidebarElement === 'function' && !utils.isMobile()));
    };
    ProFullscreen.prototype.getSmallScreenArrows = function (isNewLayout, isSmallScreen, isTouch, totalItems) {
        return false;
    };
    ProFullscreen.prototype.getFullscreenClasses = function () {
        var versionClassName = 'v2';
        var expandedClassName = this.state.isFullscreen
            ? ' pro-fullscreen-expanded '
            : '';
        var themeClassName = utils.parseGetParam('theme') === 'dark'
            ? ' fullscreen-dark'
            : ' fullscreen-bright';
        var accessibilityClassName = '';
        if (utils.isOOI()) {
            accessibilityClassName = this.props.isAccessible
                ? ' pro-fullscreen-accessible '
                : '';
        }
        else {
            accessibilityClassName = utils.isAccessibilityEnabled()
                ? ' pro-fullscreen-accessible '
                : '';
        }
        var mobileClassName = utils.isMobile() ? 'pro-fullscreen-mobile' : '';
        return "fullscreen pro-fullscreen pro-fullscreen-inline-styles inline-styles pro-fullscreen-".concat(versionClassName, " ").concat(expandedClassName, " ").concat(themeClassName, " ").concat(accessibilityClassName, " ").concat(mobileClassName);
    };
    ProFullscreen.prototype.getState = function (isMobile) {
        var state = _.pick(this.state, [
            'current',
            'animating',
            'direction',
            'showShareScreen',
            'refocusArrows',
            'initialArrowsFocus',
            'showInfo',
            'isFullscreen',
        ]);
        Object.assign(state, {
            id: state.current.item.id,
            idx: state.current.item.idx,
            itemId: state.current.item.id,
        });
        if (isMobile) {
            return __assign(__assign({}, state), { isMobileZoom: this.state.isMobileZoom, currentGalleryItem: this.state.currentGalleryItem });
        }
        return __assign(__assign({}, state), { shouldRefocusOnCloseXButton: this.state.shouldRefocusOnCloseXButton });
    };
    ProFullscreen.prototype.getProps = function (isMobile) {
        var props = _.pick(this.props, [
            'items',
            'styles',
            'additionalSidebarElement',
            'animationDuration',
            'homeGalleryPageUrl',
            'additionalNavbarElement',
            'navigatedInto',
            'customDownloadUrl',
            'isPreview',
            'locale',
            'deviceType',
            'viewMode',
            'customSidebarRenderer',
            'noFollowForSEO',
            'shouldUseNewSocialSharePopup',
            'staticMediaUrls',
            'isAccessible',
            'customComponents',
        ]);
        Object.assign(props, {
            totalItems: this.props.totalItemsCount,
        });
        if (isMobile) {
            return __assign(__assign({}, props), { customMobileSidebarRenderer: this.props.customMobileSidebarRenderer, isAdditionalMobileSidebarOpened: this.props.isAdditionalMobileSidebarOpened, container: this.props.container });
        }
        return props;
    };
    ProFullscreen.prototype.setRef = function (ref) {
        this.element = ref;
    };
    // ________________________________________________________________________________
    ProFullscreen.prototype.renderFullscreen = function () {
        var props = __assign(__assign(__assign({}, this.getState(utils.isMobile())), this.getProps(utils.isMobile())), { current: this.getItemStateByIdx(this.state.current.idx), currentWindow: this.getCurrentWindowState(), actions: this.actions, isFirst: utils.isMobile() ? true : false, hasAdditionalSidebarElement: this.hasAdditionalSidebarElement(), shouldShowInfo: this.shouldShowInfo(), fullscreenClasses: this.getFullscreenClasses(), setRef: this.setRef, itemClickIsOpenInFullscreen: this.itemClickIsOpenInFullscreen, isPrerenderMode: this.props.isPrerenderMode });
        if (utils.isMobile()) {
            return React.createElement(MobileExpand, __assign({}, props));
        }
        else {
            return React.createElement(DesktopExpand, __assign({}, props));
        }
    };
    ProFullscreen.prototype.render = function () {
        if (utils.isVerbose()) {
            console.timeEnd('Time in React');
            console.log('Render FullscreenView', this.props, this.state);
        }
        return this.renderFullscreen();
    };
    return ProFullscreen;
}(React.Component));
ProFullscreen.propTypes = {
    items: PropTypes.array,
    initialIdx: PropTypes.number,
    styles: PropTypes.object.isRequired,
    container: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    }),
    viewMode: PropTypes.string,
    locale: PropTypes.string,
    deviceType: PropTypes.string,
    isPreview: PropTypes.bool,
    eventsListener: PropTypes.func,
    itemsLoveData: PropTypes.object,
    isPrerenderMode: PropTypes.bool,
};
ProFullscreen.defaultProps = {
    items: [],
    initialIdx: 0,
    locale: 'en',
    deviceType: 'desktop',
    isPreview: false,
    viewMode: 'SITE',
};
export default withCssFilter(ProFullscreen);
//# sourceMappingURL=ProFullScreen.js.map